export type ThemeMode = "dark" | "light";

export type ThemePreference = ThemeMode | "system";

const THEME_COOKIE = "gg-theme";

export function resolveTheme(
  pref: ThemePreference | null | undefined,
): ThemeMode {
  if (pref === "dark" || pref === "light") return pref;
  if (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
  ) {
    return "dark";
  }
  return "light";
}

export function getClientThemeFallback(): ThemeMode {
  if (typeof window === "undefined") return "light";
  try {
    const stored = localStorage.getItem("theme");
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* ignore */
  }
  if (window.matchMedia?.("(prefers-color-scheme: light)").matches) {
    return "light";
  }
  return "light";
}

export function applyTheme(theme: ThemeMode): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem("theme", theme);
  } catch {
    /* ignore */
  }
  document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=31536000; samesite=lax`;
}

export function toggleTheme(current?: ThemeMode | null): ThemeMode {
  const next: ThemeMode =
    (current === "light" || current === "dark"
      ? current
      : getClientThemeFallback()) === "dark"
      ? "light"
      : "dark";
  applyTheme(next);
  return next;
}
